// @ts-nocheck

import type {SentEvent} from 'src/api-parsers/events';

import Store from './base';


export default class SentEventStore extends Store {
  state: {
    fetching: Promise<undefined> | null | undefined;
    sentEvents: {
      [key: string]: SentEvent;
    };
  };

  constructor() {
    super('sent-event');

    this.state = {
      fetching: null,
      sentEvents: {},
    };
  }

  startFetching(promise: Promise<undefined>) {
    this.setState({
      fetching: promise,
    });
  }

  receiveSentEvent(sentEvent: SentEvent) {
    this.updateState({
      fetching: {$set: null},
      sentEvents: {[sentEvent.id]: {$set: sentEvent}},
    });
  }

  byId(id: string): SentEvent | null | undefined {
    return this.state.sentEvents[id];
  }
}
